exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-54987c67] {\n  padding: 14px 20px;\n  border: 1px dashed #ddd;\n  border-radius: 10px;\n  background-color: #f5fbff;\n  margin-bottom: 20px;\n}\n.width-50[data-v-54987c67] {\n  width: 50px;\n}\n.multiple[data-v-54987c67] .el-form-item__content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.multiple[data-v-54987c67] .el-upload-list {\n  display: none;\n}\n", ""]);

// exports
